import React from 'react'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'

const useStyle = makeStyles({
  menu: {
    flex: 1,
    overflowY: 'scroll',
    '-ms-owerflow-style': 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    }
  },
  section: {
    marginBottom: '24px',
  },
  title: {
    marginBottom: '8px',
    marginLeft: '8px',
  },
  iconWrapper: {
    marginRight: '8px',
    width: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  item: {
    padding: '8px',
    margin: '2px 0',
    borderRadius: '3px',
    textDecoration: 'none',
    color: '#FFF',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.06)',
    },
    '&.active': {
      background: 'rgba(255, 255, 255, 0.06)',
      color: '#FFF',
    }
  }
})

interface IMenuItem {
  icon: string,
  route: string,
  caption: string,
}

export interface IMenuSection {
  title?: string,
  items: Array<IMenuItem>
}

type MenuProps = {
  menu: Array<IMenuSection>
}

const Menu = ({ menu }: MenuProps): JSX.Element => {
  const classes = useStyle()
  const history = useHistory()

  const renderMenu = () => (
    menu.map((menuItem, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <section className={classes.section} key={`${menuItem?.title}-${i}`}>
        {menuItem.title && <p className={classes.title}>{menuItem.title}</p>}
        {renderMenuItems(menuItem)}
      </section>
    ))
  )

  const renderMenuItems = (menuItem: IMenuSection) => (
    menuItem.items.map((item: IMenuItem) => (
      <Link
        to={item.route}
        className={clsx(classes.item, history.location.pathname === item.route && 'active')}
        key={item.route}
      >
        <div className={classes.iconWrapper}>
          <img src={item.icon} alt={item.caption} />
        </div>
        <p>{item.caption}</p>
      </Link>
    ))
  )

  return (
    <div className={classes.menu}>
      {renderMenu()}
    </div>
  )
}

export default Menu